import React, { Component, Fragment } from "react";
import { Card } from "react-blueprint-library";
import { Accordion, AccordionButton, Table } from "react-bootstrap";
import AccordionBody from "react-bootstrap/esm/AccordionBody";

function formatValue(value) {
  if (value === null) {
    value = 0;
  }
  return value;
}
class PersonalSalesRecordFinancialPlans extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="row">
        <div className="col-md-12">
          <Card>
            <Accordion>
              <div className="mm-collapse">
                <AccordionButton
                  id="psr_financial_plans"
                  className="btn-collapse"
                >
                  <table width="100%">
                    <tbody>
                      <tr className="psr-first-row">
                        <td>
                          <div className="psr-button-text">
                            <strong className="footer-link psr-accordion">
                              <span>{`Financial Plans:`}</span>
                              <span>{this.props.data.totalFinPlans}</span>
                            </strong>
                          </div>
                          <div className="chevron-wrapper">
                            <span className="indicator psr-chevron"></span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </AccordionButton>
                <AccordionBody>
                  <Table borderless responsive className="psr-charts-table">
                    <thead>
                      <tr>
                        <th
                          style={{
                            alignItems: "center",
                            display: "flex",
                            minWidth: "130px",
                          }}
                        >
                          <strong>Financial Plans</strong>
                        </th>
                        {Array.from(this.props.financialData).map(
                          (psr, key) => {
                            return (
                              <Fragment key={key}>
                                {key === 0 && (
                                  <th
                                    width="13%"
                                    style={{ minWidth: "100px" }}
                                    className="psr-cell-center"
                                  >
                                    <strong>
                                      Current Year<br></br>
                                      {this.props.financialData[key][0]}
                                    </strong>
                                  </th>
                                )}
                                {key > 0 && (
                                  <th
                                    width="13%"
                                    style={{ minWidth: "100px" }}
                                    className="psr-cell-center"
                                  >
                                    <strong>
                                      Year {key}
                                      <br></br>
                                      {this.props.financialData[key][0]}
                                    </strong>
                                  </th>
                                )}
                              </Fragment>
                            );
                          }
                        )}
                      </tr>
                    </thead>
                    <tbody className="sortable">
                      <tr>
                        <td>Number Sold</td>
                        {Array.from(this.props.financialData).map(
                          (psr, key) => {
                            return (
                              <Fragment key={key}>
                                <td style={{ textAlign: "center" }}>
                                  {formatValue(
                                    this.props.financialData[key][1]
                                  )}
                                </td>
                              </Fragment>
                            );
                          }
                        )}
                      </tr>
                    </tbody>
                  </Table>
                </AccordionBody>
              </div>
            </Accordion>
          </Card>
        </div>
      </div>
    );
  }
}

export default PersonalSalesRecordFinancialPlans;
